/**
 * Formata as datas da coluna "Período Solicitado" do histórico de integração.
 *
 * `DataPesquisada` e `DataPesquisadaFim` sao datas de filtro, nao instantes:
 * o backend grava o dia truncado (`ObterDias` usa `dataInicio.Date`) e o Mongo
 * devolve o valor com `Kind = Utc`, entao o JSON chega como
 * `2026-09-28T00:00:00Z`. Converter isso para o fuso do navegador (UTC-3)
 * jogaria o horario para 21:00 do dia anterior e a coluna mostraria um dia a
 * menos do que foi solicitado.
 *
 * O legado nao tinha esse problema porque lia o dia direto da string, sem
 * conversao de fuso (`f360.parseDate` em `Scripts/util.js` faz
 * `kendo.parseDate(date.substr(0, 10))`). Aqui mantemos a mesma semantica.
 */
const ISO_DATE_PREFIX = /^(\d{4})-(\d{2})-(\d{2})/;

export const formatPeriodoSolicitado = (
  value?: string | Date | null
): string => {
  if (!value) return "";

  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return "";

    // Mesma leitura do legado: `toISOString().substr(0, 10)` usa as partes UTC.
    return formatPeriodoSolicitado(value.toISOString());
  }

  const trimmedValue = value.trim();
  const isoDateMatch = ISO_DATE_PREFIX.exec(trimmedValue);

  if (!isoDateMatch) return trimmedValue;

  const [, year, month, day] = isoDateMatch;

  return `${day}/${month}/${year}`;
};

export default formatPeriodoSolicitado;
